import React, { useEffect, useState } from 'react';
import { DrivingExemptionForm, SubmitDrivingExemptionModel, SubmitOnBehalfDrivingExemptionModel } from 'shared/models/api/models';
import { MultilineTextInput, UserChoice, YesNoCheck, YesNoChoice } from '../fatigueAssessment/FormControls';
import DrivingExemptionQuestions from './DrivingExemptionQuestions';
import {
    DateChoice,
    DepartmentManagerChoices,
    HoursOfDrivingChoices,
    LvTravelShifChoices,
    PositionLevelChoices,
    RPUserReportManager,
    SingleLineTextInput,
    VehicleOwnerChoices
} from '../forms/FormControls';
import {
    drivingExemptionFormState as de,
    DrivingExemptionFormState,
    emailValidation,
    enableValidation,
    fieldInvalid,
    handleChange,
    handleCheckboxChange} from './DrivingExemptionFormState';
import { ExemptionFormTypeEnum } from '../../../shared/enums/exemption-form-type-enum';
import { questionsUnanswered } from '../forms/util';
import { Button } from 'reactstrap';
import { submitDrivingExemption, submitOnBehalfDrivingExemption, validateManagerEmail } from '../../../shared/services/drivingExemptionApi';
import { FormModal, FormModalPaddedBody, FormModalSubHeader, ModalButton, ModalButtonRow } from '../../ui/FormModal';
import { InfoOutlined as InfoIcon, Warning as WarningIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { gnhUsersSubmittedFormListRoute } from './DrivingExemptionRoutes';
import InfoModal from '../../ui/InfoModal';
import { NotApplicableEnum, NotApplicableEnumToString } from '../../../shared/enums/not-applicable-enum';
import { getUserProfile } from '../../../shared/services/userApi';
import { isoDateStringToBrowserSafeString } from '../../../shared/models/mapping/mapping';
import { ToolTipButton } from '../../menu/Labels';
import FatigueAssessmentQuestions from '../fatigueAssessment/FatigueAssessmentQuestions';

interface MainFormProps {
    formType: ExemptionFormTypeEnum,
    onBehalf?: boolean
}

    const MainForm = (props: MainFormProps) => {  
    const [onBehalf] = useState(props.onBehalf === true);
    const [form, setForm] = useState({} as DrivingExemptionForm);
    const [invalidEmail, setInvalidEmail] = useState(false);
    const [emailExist, setEmailExist] = useState(false);
    const [showEmailNotExisting, setShowEmailNotExisting] = useState(false);
    const [showMonitoringInstallationArrangements, setShowMonitoringInstallationArrangements] = useState(false);
    const [isEmailSame, setIsEmailSame] = useState(false);
    const [bhpOwned, setBhpOwned] = useState(false);
    const [dssInstalled, setDssInstalled] = useState(-1);
    const [defaultStartDate, setDefaultStartDate] = useState(form.startDate);
    const [defaultEndDate, setDefaultEndDate] = useState(form.endDate);
    const [showDatePicker, setShowDatePicker] = useState(true);
    const [userReportManager, setuserReportManager] = useState<number | undefined>(undefined);

    const q = DrivingExemptionQuestions;

    const handleMouseOut = () => (event: any) => {
        let value = event;

        if (value.target?.value !== undefined) {
            value = value.target.value;
        }
        if (value.value !== undefined) {
            value = value.value;
        }

        const checkEmailExist = async () => {
            const up = await getUserProfile();
            if (!value) {
                setEmailExist(false);
                setShowEmailNotExisting(false);
            } else if (initialEmailValidation.test(value)) {
                const emailSameAsCurrentUser = value === up?.email;
                if (emailSameAsCurrentUser) {
                    setIsEmailSame(true);
                    setEmailExist(false);
                }

                if (!emailSameAsCurrentUser) {
                    const isValidEmail = await validateManagerEmail(value);
                    setEmailExist(isValidEmail);
                    setShowEmailNotExisting(!isValidEmail);
                    emailValidation(isValidEmail);
                }
            }
        }

        checkEmailExist();
    }

    useEffect(() => {
        const sub = de.subscribe((d: DrivingExemptionFormState) => {
            setForm(d.form);

            if (d.form.monitoringSystemInstalled?.valueOf()) {
                setShowMonitoringInstallationArrangements(Number(d.form.monitoringSystemInstalled) === 0);
            }

            if (d.form.bhpOwnedOrHiredLV?.valueOf()) {
                setBhpOwned(Number(d.form.bhpOwnedOrHiredLV) === 1);
            }

            if (Number(d.form.bhpOwnedOrHiredLV) === 1) {
                d.form.monitoringSystemInstalled = undefined;
                d.form.hiredLVMonitoringSysInstallationArrangements = undefined;
            }

            if (d.form.twelveMonthsExemption?.valueOf() !== undefined) {
                setShowDatePicker(Number(d.form.twelveMonthsExemption?.valueOf()) === 0);
            }
            if (Number(d.form.user?.id)>0) {
                setuserReportManager(Number(d.form.user?.id));
                
            }
            setInvalidEmail(validateEmail(d.form.reportToEmail));
            setDssInstalled(Number(d.form.dssInstalled));
            setDefaultStartDate(d.form.startDate);
            setDefaultEndDate(d.form.endDate);
        });

        return () => { sub.unsubscribe(); };
    }, [form]);

    return (
        <div key={form.id}>
            {onBehalf === true &&
                <>
            <div className="main-form-row">Questions are phrased as the user would read them. Please answer on behalf of the user relative to the time of submitting the driving exemption assessment.</div>
            <div className="main-form-row row-divider">
                <div className="question">{q.onBehalfUser.value}<ToolTipButton text={q.onBehalfUser.tooltip} /></div>
                <div className="answer">
                        <UserChoice 
                        onAnswerUpdate={handleChange(q.onBehalfUser.key)}
                        invalid={fieldInvalid(q.onBehalfUser.key)} />
                </div>
                </div>
            </>
            }
            <div className="main-form-row row-divider">
                <div className="question">{ q.positionLevel.value}</div>
                <div className="answer">
                    <PositionLevelChoices
                        onAnswerUpdate={handleChange(q.positionLevel.key)}
                        invalid={fieldInvalid(q.positionLevel.key)} />
                </div>
            </div>

            <div className="main-form-row row-divider">
                <div className="question">{q.reportToEmail.value}</div>
                <div className="answer"><RPUserReportManager key={userReportManager} id={userReportManager } /></div>
                <div className="question"></div>
                <div style={{ marginTop: 10 }} className="answer">
                    <SingleLineTextInput
                        onAnswerUpdate={handleChange(q.reportToEmail.key)}
                        invalid={invalidEmail}
                        placeholder="Type in your 1-UP Leader email address if the one above is not the current one"
                        onMouseOutUpdate={handleMouseOut()}
                        emailExist={emailExist}
                    />
                    {invalidEmail &&
                        <div className="email-validation-error-msg">Please enter a valid email address of your 1-UP Leader</div>
                    }
                    {showEmailNotExisting &&
                        <div className="email-validation-error-msg">The email address you have entered does not exist. Please enter a valid email address</div>
                    }
                    {isEmailSame &&
                        <div className="email-validation-error-msg">Email address cannot be the same as the current user</div>
                    }
                </div>
            </div>

            <div className="main-form-row row-divider">
                <div className="question">{q.deptManagerId.value}</div>
                <div className="answer">
                    <DepartmentManagerChoices
                        onAnswerUpdate={handleChange(q.deptManagerId.key)}
                        invalid={fieldInvalid(q.deptManagerId.key)} />
                </div>
            </div>

            {props.formType === ExemptionFormTypeEnum.GNH &&
                <>
                    <div className="main-form-row row-divider">
                        <div className="question">{q.dssInstalled.value}</div>
                        <div className="answer">
                            <YesNoChoice name={q.dssInstalled.key}
                                onAnswerUpdate={handleChange(q.dssInstalled.key)}
                                invalid={fieldInvalid(q.dssInstalled.key)}
                            />
                            {dssInstalled === 0 &&
                                <div className="email-validation-error-msg">This request cannot be submitted for a vehicle without DSS installed</div>
                            }
                        </div>
                    </div>                    
                </>
            }

            {props.formType === ExemptionFormTypeEnum.GNH &&
                <>
                    <div className="main-form-row row-divider">
                        <div className="question">{q.bhpOwnedOrHiredLV.value}</div>
                        <div className="answer">
                            <VehicleOwnerChoices
                                onAnswerUpdate={handleChange(q.bhpOwnedOrHiredLV.key)}
                                invalid={fieldInvalid(q.bhpOwnedOrHiredLV.key)} />
                        </div>
                    </div>

                {!bhpOwned &&
                    <>
                    <div className="main-form-row row-divider">
                        <div className="question">{q.monitoringSystemInstalled.value}</div>
                        <div className="answer">
                            <YesNoChoice name={q.monitoringSystemInstalled.key}
                                onAnswerUpdate={handleChange(q.monitoringSystemInstalled.key)}
                                invalid={fieldInvalid(q.monitoringSystemInstalled.key)}
                            />
                        </div>
                    </div>

                    {showMonitoringInstallationArrangements &&
                    <>
                        <div className="main-form-row row-divider">
                            <div className="question">{q.hiredLVMonitoringSysInstallationArrangements.value}</div>
                            <div className="answer">
                                <MultilineTextInput
                                    onAnswerUpdate={handleChange(q.hiredLVMonitoringSysInstallationArrangements.key)}
                                    invalid={fieldInvalid(q.hiredLVMonitoringSysInstallationArrangements.key)}
                                />
                            </div>
                        </div>
                    </>
                    }
                    </>
                }                    
                </>
            }

            <div className="main-form-row row-divider">
                <div className="question">{q.lvAssetName.value}</div>
                <div className="answer">
                    <SingleLineTextInput
                        onAnswerUpdate={handleChange(q.lvAssetName.key)}
                        invalid={fieldInvalid(q.lvAssetName.key)}
                        placeholder="Type in LV Asset name"
                    />
                </div>
            </div>

            {props.formType === ExemptionFormTypeEnum.LVCommute &&
                <>
                    <div className="main-form-row row-divider">
                        <div className="question">{q.lvRegistrationNumber.value}</div>
                        <div className="answer">
                            <SingleLineTextInput
                                onAnswerUpdate={handleChange(q.lvRegistrationNumber.key)}
                                invalid={fieldInvalid(q.lvRegistrationNumber.key)}
                                placeholder="Type in LV registration number"
                            />
                        </div>
                    </div>

                    <div className="main-form-row row-divider">
                        <div className="question">{q.requiredToAttendSiteoutsideOfNormalBusiness.value}</div>
                        <div className="answer">
                            <YesNoChoice name={q.requiredToAttendSiteoutsideOfNormalBusiness.key}
                                onAnswerUpdate={handleChange(q.requiredToAttendSiteoutsideOfNormalBusiness.key)}
                                invalid={fieldInvalid(q.requiredToAttendSiteoutsideOfNormalBusiness.key)}
                            />
                        </div>
                    </div>
                </>
            }

            <div className="main-form-row row-divider">
                <div className="question">Is the driving exemption request for 12 months?</div>
                <div className="answer">
                    <YesNoChoice name={q.twelveMonthsExemption.key}
                        onAnswerUpdate={handleChange(q.twelveMonthsExemption.key)}
                        invalid={fieldInvalid(q.twelveMonthsExemption.key)}
                    />
                </div>
            </div>

            {showDatePicker &&
                <>
                    <div className="main-form-row row-divider">
                        <div className="question">{q.startDate.value}</div>
                        <div className="answer">
                            <DateChoice date={defaultStartDate}
                                onAnswerUpdate={handleChange(q.startDate.key)}
                                invalid={fieldInvalid(q.startDate.key)}
                            />
                        </div>
                    </div>

                    <div className="main-form-row row-divider">
                        <div className="question">{q.endDate.value}</div>
                        <div className="answer">
                            <DateChoice date={defaultEndDate}
                                onAnswerUpdate={handleChange(q.endDate.key)}
                                invalid={fieldInvalid(q.endDate.key)}
                            />
                        </div>
                    </div>
                </>
            }

            <div className="main-form-row row-divider">
                {props.formType === ExemptionFormTypeEnum.GNH &&
                    <>
                    <div className="question">{q.hoursOfDriving.value}</div>
                    <div className="answer">
                        <HoursOfDrivingChoices
                            onAnswerUpdate={handleChange(q.hoursOfDriving.key)}
                            invalid={fieldInvalid(q.hoursOfDriving.key)} />
                    </div>
                    </>
                }
                {props.formType === ExemptionFormTypeEnum.LVCommute &&
                    <>
                    <div className="question">{q.lVTravelShift.value}</div>
                        <div className="answer">
                        <LvTravelShifChoices
                            onAnswerUpdate={handleChange(q.lVTravelShift.key)}
                            invalid={fieldInvalid(q.lVTravelShift.key)} />
                        </div>
                    </>
                }
                </div>
              

            <div className="main-form-row row-divider">
                {props.formType === ExemptionFormTypeEnum.GNH &&
                    <>
                    <div className="question">Please provide justification for your request for a driving exemption</div>
                    </>
                }
                {props.formType === ExemptionFormTypeEnum.LVCommute &&
                    <>
                    <div className="question">Please provide justification for your request for commute exemption</div>
                    </>
                }
                <div className="answer">
                    <MultilineTextInput
                        onAnswerUpdate={handleChange(q.drivingExemptionJustification.key)}
                        invalid={fieldInvalid(q.drivingExemptionJustification.key)}
                    />
                </div>
            </div>

            {props.formType === ExemptionFormTypeEnum.GNH &&
                <>
                    <div className="main-form-row row-divider">
                        <div className="question" dangerouslySetInnerHTML={{ __html: q.gnhTermsAcknowledgement.value }}></div>
                        <div className="answer">
                            <YesNoCheck name={q.gnhTermsAcknowledgement.key} onAnswerUpdate={handleCheckboxChange(q.gnhTermsAcknowledgement.key)} invalid={fieldInvalid(q.gnhTermsAcknowledgement.key)} />
                        </div>
                    </div>
                </>
            }

            {props.formType === ExemptionFormTypeEnum.LVCommute &&
                <>
                    <div className="main-form-row row-divider">
                        <div className="question" dangerouslySetInnerHTML={{ __html: q.lvCommuteTermsAcknowledgement.value }}></div>
                        <div className="answer">
                            <YesNoCheck name={q.lvCommuteTermsAcknowledgement.key} onAnswerUpdate={handleCheckboxChange(q.lvCommuteTermsAcknowledgement.key)} invalid={fieldInvalid(q.lvCommuteTermsAcknowledgement.key)} />
                        </div>
                    </div>
                </>
            }            
            
        </div>
    );
}

export const initialEmailValidation: RegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const validateEmail = (emailAddress: string | undefined): boolean => {
    if (emailAddress?.valueOf().length === 0) {
        return false;
    }

    if (emailAddress?.valueOf() !== undefined) {
        const emailValidation = emailAddress !== "NA" ? !initialEmailValidation.test(emailAddress) : false;
        return emailValidation;
    }    

    return false;
};

type ResultModalProps = {
    submittedExemptionId: number,
    isOpen: boolean,
    formType: ExemptionFormTypeEnum,
    closeAction: () => void
}

const ResultModal = (props: ResultModalProps) => {
    const formTitle = () => {
        if (props.formType == ExemptionFormTypeEnum.GNH) {
            return "GNH Driving Exemption form";
        }
        return "LV Commute Exemption Form";
    }

    return (
        <FormModal {...props} headingText={formTitle()}>

            <FormModalSubHeader>
                <div>{`Thank you for submitting the ${formTitle()}.`}</div>
            </FormModalSubHeader>

            <FormModalPaddedBody>
                <div className="modal-body-content-container">

                    <div className="modal-body-content">
                        {typeof props.submittedExemptionId !== 'number' ?
                            <div className="p-2 pb-5"><WarningIcon className="icon-score-low mr-4" />Something went wrong. Please raise an Incident or contact the Service Desk.</div>
                            :
                            <div className="p-2 pb-5">
                                <InfoIcon className="icon-score-low mr-4 mb-3" />
                                <div className="d-inline-block">
                                    Exemption request form successfully submitted.<br />
                                    You will be notified of the progress of your request by email.
                                </div>
                            </div>
                        }
                    </div>

                    <ModalButtonRow>
                        <ModalButton onClick={props.closeAction} text="OK" primaryButton={true} />
                    </ModalButtonRow>

                </div>
            </FormModalPaddedBody>
        </FormModal>
    );
}

interface FormContentProps {
    onBehalf?: boolean,
    formType: ExemptionFormTypeEnum
}

const FormContents = (props: FormContentProps) => {
    const [onBehalf] = useState(props.onBehalf === true);
    const [displayAllRequired, setAllRequired] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [form, setForm] = useState({} as DrivingExemptionForm);
    const [displayResponseModal, setResponseModal] = useState(false);
    const [responseId, setResponseId] = useState(0);
    const [displayErrorSubmitting, setErrorSubmitting] = useState(false);
    const [isEmailValid, setIsEmailValid] = useState(false);
    const [dssInstalled, setDssInstalled] = useState(false);
    const [finalEmailValidation, setFinalEmailValidation] = useState(false);

    const navigate = useNavigate();

    const onSubmit = async () => {
        if ((props.formType == ExemptionFormTypeEnum.GNH && dssInstalled) || props.formType == ExemptionFormTypeEnum.LVCommute) {
            setIsSubmitting(true);
        }
        enableValidation();

        let submitDrivingExemption = getDrivingExemptionFromCurrentForm();
        let unansweredCount = 0;

        try {
            unansweredCount = await submitIfAble(submitDrivingExemption);
        }
        finally {
            if (unansweredCount > 0 || !isEmailValid) {
                setAllRequired(true);
                setIsSubmitting(false);
            }
        }
    }

    const getDrivingExemptionFromCurrentForm = () => {
        let drivingExemption = {} as SubmitDrivingExemptionModel;
        const currentDate = new Date();
        const hours = currentDate.getHours().toString();
        const mins = currentDate.getMinutes().toString();
        drivingExemption.drivingExemptionFormType = props.formType;
        drivingExemption.positionLevel = form.positionLevel;
        drivingExemption.reportToEmail =
            form.reportToEmail?.valueOf() !== undefined ? form.reportToEmail : NotApplicableEnumToString(NotApplicableEnum.NA);
        drivingExemption.deptManagerId = form.deptManagerId;
        drivingExemption.bhpOwnedOrHiredLV =
            props.formType === ExemptionFormTypeEnum.GNH ? form.bhpOwnedOrHiredLV : NotApplicableEnum.NA.toString();
        drivingExemption.monitoringSystemInstalled =
            props.formType === ExemptionFormTypeEnum.GNH && Number(form.bhpOwnedOrHiredLV) !== 1 ? Number(form.monitoringSystemInstalled || -1) : -2;
        drivingExemption.hiredLVMonitoringSysInstallationArrangements =
            Number(form.monitoringSystemInstalled) === 0 &&
                props.formType === ExemptionFormTypeEnum.GNH ? form.hiredLVMonitoringSysInstallationArrangements : NotApplicableEnumToString(NotApplicableEnum.NA);
        drivingExemption.lvAssetName = form.lvAssetName;
        drivingExemption.hoursOfDriving =
            props.formType === ExemptionFormTypeEnum.GNH ? form.hoursOfDriving : NotApplicableEnum.NA.toString();
        drivingExemption.drivingExemptionJustification = form.drivingExemptionJustification;
        drivingExemption.lvRegistrationNumber =
            props.formType === ExemptionFormTypeEnum.LVCommute ? form.lvRegistrationNumber : NotApplicableEnumToString(NotApplicableEnum.NA);
        drivingExemption.requiredToAttendSiteoutsideOfNormalBusiness =
            props.formType === ExemptionFormTypeEnum.LVCommute ? Number(form.requiredToAttendSiteoutsideOfNormalBusiness || -1) : -2;
        drivingExemption.dssInstalled =
            props.formType === ExemptionFormTypeEnum.GNH ? Number(form.dssInstalled || -1) : -2;
        drivingExemption.termsAcknowledgement = form.gnhTermsAcknowledgement || form.lvCommuteTermsAcknowledgement;
        let startDate = isoDateStringToBrowserSafeString(`${form.startDate}T${hours}:${mins}:00`);
        let updatedStartDate = new Date(startDate);
        drivingExemption.startDate = updatedStartDate;
        let endDate = isoDateStringToBrowserSafeString(`${form.endDate}T${hours}:${mins}:00`);
        let updatedEndDate = new Date(endDate);
        drivingExemption.endDate = updatedEndDate;
        drivingExemption.twelveMonthsExemption = Number(form.twelveMonthsExemption);
        drivingExemption.lVTravelShift =
            props.formType === ExemptionFormTypeEnum.LVCommute ? form.lVTravelShift : NotApplicableEnum.NA.toString();
        return drivingExemption;
    }

    const submitIfAble = async (drivingExemption: SubmitDrivingExemptionModel) => {
        let unansweredCount = 0;

        unansweredCount = questionsUnanswered(drivingExemption);
        let isValidEmailReCheck = false;
        if (!isEmailValid) {
            isValidEmailReCheck = await validateManagerEmail(drivingExemption?.reportToEmail);
            setFinalEmailValidation(!isValidEmailReCheck);
        }
        
        const finalEmailValidationFailed = isEmailValid || isValidEmailReCheck;  
       
        if (unansweredCount === 0 && finalEmailValidationFailed) {
            if ((props.formType == ExemptionFormTypeEnum.GNH && dssInstalled) || props.formType == ExemptionFormTypeEnum.LVCommute) {
                if (props.onBehalf) {
                    let submitOnBehalf = { ...drivingExemption } as SubmitOnBehalfDrivingExemptionModel;
                    submitOnBehalf.userId = Number(form.user?.id || -1);
                   

                    
                    submitOnBehalfDrivingExemption(submitOnBehalf).then(submitResponse);
                }
                else {
                    submitDrivingExemption(drivingExemption).then(submitResponse);
                }
                   
            }
        }

        return unansweredCount;
    }

    const submitResponse = (exemptionId: number) => {
        setIsSubmitting(false);

        if (typeof exemptionId !== 'number') {
            errorResponse(undefined);
            return;
        }

        showResponse(exemptionId);
    }

    const showResponse = (exemptionId: number) => {
        setResponseId(exemptionId);
        setResponseModal(true);
        de.reset();
    }

    const errorResponse = (e: any) => {
        if (e !== undefined) {
            console.error(e);
        }
        setIsSubmitting(false);
    }

    const closeResponse = () => {
        setResponseModal(false);
        navigate(`${gnhUsersSubmittedFormListRoute.path}`);
    }

    useEffect(() => {
        const deSub = de.subscribe((d: DrivingExemptionFormState) => {
            setForm(d.form);
            setAllRequired(false);

            if (d.form.reportToEmail || (!d.form.reportToEmail && !d.useAutoPopulatedReportToEmail)) {
                setIsEmailValid(d.emailInvalid);
            }
            else if (d.useAutoPopulatedReportToEmail)
            {
                setIsEmailValid(d.useAutoPopulatedReportToEmail);
            }

            setDssInstalled(Number(d.form.dssInstalled) === 1);
        });

        return () => {
            deSub.unsubscribe();
        };
    }, [form]);

    useEffect(() => {
        de.reset();
    }, []);

    return (
        <div className="de-list-container">
            <div className="main-form-header">Enter all details and click submit</div>

            <InfoModal text="There was an issue submitting the exemption request. Please try again." isOpen={displayErrorSubmitting} closeAction={() => { setErrorSubmitting(false); }} />

            <ResultModal submittedExemptionId={responseId} formType={props.formType} isOpen={displayResponseModal} closeAction={closeResponse} />

            <MainForm formType={props.formType} onBehalf={props.onBehalf}></MainForm>

            <div className="main-form-row form-end">
                <div className={`invalid-feedback mandatory-details${finalEmailValidation === true ? " show" : ""}`}>1 - UP email address validation failed.</div>
                <div className={`invalid-feedback mandatory-details${displayAllRequired === true ? " show" : ""}`}>Please enter all mandatory details in the form.</div>
                <div className="submit">
                    {isSubmitting ?
                        <>
                            <div className="modal fade show" role="dialog" tabIndex={-1}></div>
                            <Button className="btn-primary disabled">Submitting...</Button>
                        </>
                        :
                        <>
                            <Button className={`btn-primary ${props.formType == ExemptionFormTypeEnum.GNH && !dssInstalled ? "disabled" : ""}`} onClick={onSubmit}>Submit</Button>
                        </>
                    }
                </div>
            </div>
        </div>

    );
}

export default FormContents;
